import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Navigate } from 'react-router';
import { makeLinks, withRouter } from 'utils/common';
import { partial } from 'underscore';
import axios from 'axios';
import moment from 'moment';
import endpoints from 'utils/endpoints';
import ContractTypeData from './Pages/ContractTypeData';
import PersonalData from './Pages/PersonalData';
import Summary from './Pages/Summary';
import PaymentSuccess from 'components/PaymentSuccess';
import PaymentError from 'components/PaymentError';
import Head from 'components/Head';
import i18n from 'utils/translate';
import { getQueryStringParams } from 'utils/common';
import { PAYMENT_RESPONSE } from 'utils/constants';
import { insertAfter } from 'utils/common';
import { animateScroll } from 'react-scroll';
import initTranslationsMKD from './translations_mkd';
import './styles.scss';

import { DATA_STORAGE_KEY, PAYMENT_STORAGE_KEY } from './constants';
import PaymentData from './Pages/PaymentData';

class LifeInsuranceFormMkdContainer extends Component {
  constructor(props) {
    super(props);

    initTranslationsMKD();

    const { location } = props;
    const steps = [
      { text: i18n('Step 1 / Contract'), url: '' },
      { text: i18n('Step 2 / Contract Data'), url: 'contract-data' },
      { text: i18n('Step 3 / Payment'), url: 'payment' },
      { text: i18n('Step 4 / Completion'), url: 'summary' }
    ];

    this.params = {};
    this.ajaxLoading = false;
    this.blockPayment = false;

    this.state = {
      loading: false,
      apiErrorMessages: [],
      restored: false
    };

    if (location.pathname.indexOf('/summary') === -1) {
      sessionStorage.clear();
    }

    this.initializeData();

    this.steps = steps.map(step => ({
      ...step,
      path: `${step.path}`
    }));

    // TODO
    this.urls = {
      contract: '/',
      personal: '/contract-data',
      payment: '/payment',
      summary: '/summary',
      success: '/success',
      error: '/error'
    };
  }

  initializeData = () => {
    this.data = {
      contract: {
        type: 0,
        premium: '555,55'
      },
      personal: {}
    };
  };

  componentDidMount() {
    // Restore data (if any) from temporary storage
    const frozen = sessionStorage.getItem(DATA_STORAGE_KEY);
    if (frozen === null) {
      this.setState({
        restored: true
      });
      return;
    }
    try {
      const data = JSON.parse(frozen);
      this.data = data;

      this.setState({ ...data, restored: true });
    } catch (e) {
      // Nothing to do here: this was an optional op
    }
  }

  updateData = (key, value) => {
    this.data[key] = value;
    this.setState({ [key]: value });
  };

  resetApiErrors = () => {
    this.setState({
      apiErrorMessages: []
    });
  };

  storeTemporarily() {
    // store data to be temporarily picked up by re-navigation
    const frozen = JSON.stringify(this.data);
    sessionStorage.setItem(DATA_STORAGE_KEY, frozen);
  }

  makeOrderModel() {
    const {
      personal: { firstname, lastname, premium, email, address, city, country, telephone }
    } = this.data;

    // const prefix = window.base === '/' ? '' : window.base;

    return {
      offerNumber: '12345',
      policyNumber: '12345',
      amount: premium,
      currency: 'KORIN',
      firstname,
      lastname,
      address,
      city,
      country,
      telephone,
      email
    };
  }

  getPolicyPayment = contractDetails => {
    const { insuranceNumber, birthdate } = contractDetails;
    const data = {
      policyNumber: insuranceNumber,
      dateOfBirth: moment(birthdate).format('DD.MM.YYYY')
    };

    console.log('POST REQUEST getPolicyPayment ', data);

    return axios({
      baseURL: 'https://paymentservice.grawe.at/PaymentGateway/',
      url: 'api/v1/cpay/getPolicyPayment',
      // url: endpoints.paymentFormMk.GET_POLICY_PAYMENT,
      method: 'post',
      data,
      withCredentials: true
    })
      .then(resp => {
        if (resp.data.ok) {
          this.data.documents = {
            ...resp.data
          };

          this.storeTemporarily();
          setTimeout(() => {
            // TODO What next
          });
          this.setState({
            loading: false
          });
        } else {
          this.setState({
            loading: false,
            apiErrorMessages: [
              {
                validierungsText: `${i18n('Receiving policy details failed')}`
              }
            ]
          });
        }
      })
      .catch(error => {
        this.setState({
          loading: false,
          apiErrorMessages: [
            {
              validierungsText: `${i18n('Receiving policy details failed')}`
            }
          ]
        });
      });
  };

  placeCreditCardOrder() {
    const data = this.makeOrderModel();
    this.storeTemporarily();

    return axios({
      // TODO?
      baseURL: GRAWE.api_root_mk,
      url: endpoints.paymentFormMk.CPAY_ORDER,
      method: 'post',
      data,
      withCredentials: true,
      crossdomain: true
    })
      .then(resp => {
        if (resp.data.ok) {
          this.data.documents = {
            ...resp.data
          };

          this.storeTemporarily();
          setTimeout(() => {
            console.debug('GRAWE response:', resp.data);
            const confirmationPage = document.getElementById('payment-summary');

            let widgetWrapper = document.createElement('div');
            widgetWrapper.setAttribute('id', 'widgetWrapper');

            let hobexWidgetOptions = document.createElement('script');
            hobexWidgetOptions.text = 'var wpwlOptions = {locale: "de"}';

            let hobexWidget = document.createElement('script');
            hobexWidget.src = resp.data.hobexUrl;

            let hobexForm = document.createElement('form');
            hobexForm.classList.add('paymentWidgets');
            hobexForm.setAttribute('data-brands', 'MASTER VISA');
            hobexForm.action = window.location.href + '?callback=' + resp.data.actionUrl;

            confirmationPage.classList.add('hidden');
            animateScroll.scrollToTop({ duration: 0 });
            widgetWrapper.appendChild(hobexWidgetOptions);
            widgetWrapper.appendChild(hobexWidget);
            widgetWrapper.appendChild(hobexForm);
            insertAfter(widgetWrapper, confirmationPage);
            window.onpopstate = function (event) {
              const widgetWrapperEl = document.getElementById('widgetWrapper');
              widgetWrapperEl && widgetWrapperEl.remove();
            };
          });
          this.setState({
            loading: false
          });
        } else {
          this.setState({
            loading: false,
            apiErrorMessages: [
              {
                validierungsText: `${i18n('Credit card payment failed')}`
              }
            ]
          });
        }
      })
      .catch(error => {
        this.setState({
          loading: false,
          apiErrorMessages: [
            {
              validierungsText: `${i18n('Credit card payment failed')}`
            }
          ]
        });
      });
  }

  placeOrder = () => {
    const { loading } = this.state;

    if (loading) {
      console.debug('Place order: Already in progress');
      return;
    }

    this.setState(
      {
        loading: true
      },
      () => {
        this.placeCreditCardOrder();
      }
    );
  };

  makeLinks(previous, current, next) {
    const { navigate, location } = this.props.router;

    return makeLinks(previous, current, next, navigate, location);
  }

  handleCreditCardPayment = (params, storno = false) => {
    const url = GRAWE.api_root_mk + decodeURIComponent(params.callback);

    if (window.dataLayer) {
      window.dataLayer.push({
        ecommerce: {
          purchase: {
            actionField: {
              id: this.data.personal.paymentReference,
              affiliation: 'PaymentFormMacedonia',
              revenue: this.data.personal.premium
            },
            products: [
              {
                name: 'OnlinePremiumPaymentMK',
                price: this.data.personal.premium,
                category: 'PaymentFormMacedonia',
                variant: 'Folgepraemie',
                quantity: 1
              }
            ]
          }
        }
      });
    }

    return axios({
      url,
      withCredentials: true
    });
  };

  renderContractTypePage = () => {
    const props = {
      ...this.makeLinks(null, this.urls.contract, this.urls.personal),
      onChange: partial(this.updateData, 'contract'),
      getPolicyPaymentDetails: this.getPolicyPayment,
      getOfferPaymentDetails: this.getPolicyPayment,
      data: this.data.contract
    };

    return <ContractTypeData {...props} />;
  };

  renderPersonalDataPage = () => {
    const {
      contract: { type, birthdate }
    } = this.data;
    const props = {
      ...this.makeLinks(this.urls.contract, this.urls.personal, this.urls.payment),
      onChange: partial(this.updateData, 'personal'),
      data: {
        ...this.data.personal,
        type,
        birthdate
      }
    };

    return <PersonalData {...props} />;
  };

  renderPaymentPage = () => {
    const {
      personal: { firstname, lastname, email },
      contract: { type, premium }
    } = this.data;
    const props = {
      ...this.makeLinks(this.urls.personal, this.urls.payment, this.urls.summary),
      onChange: partial(this.updateData, 'payment'),
      data: { ...this.data.payment, firstname, lastname, email, type, premium }
    };

    return <PaymentData {...props} />;
  };

  renderSummaryPage = () => {
    const { navigate } = this.props.router;
    let errorMessages = [];

    // paymentReference and premium are always included
    const { paymentReference, premium, ...formData } = this.data.personal;
    if (!Object.keys(formData).length) {
      return <Navigate replace to={this.urls.personal} />;
    }

    if (window.location.hash.indexOf('callback') > 0) {
      if (
        !sessionStorage.getItem(DATA_STORAGE_KEY) ||
        (!this.ajaxLoading && JSON.parse(sessionStorage.getItem(PAYMENT_STORAGE_KEY)))
      ) {
        sessionStorage.clear();
        this.initializeData();
        return <Navigate replace to={this.urls.personal} />;
      }

      this.params = getQueryStringParams();
      const hash = window.location.hash;
      // extract string between ? and first =, this should be the first param
      this.paramsFirst = hash.substring(hash.indexOf('?') + 1, hash.indexOf('='));

      if (this.paramsFirst === 'callback' && !this.ajaxLoading) {
        this.ajaxLoading = true;
        sessionStorage.setItem(PAYMENT_STORAGE_KEY, true);
        this.handleCreditCardPayment(this.params).then(
          ({ data }) => {
            if (
              (data.ok && data.status === PAYMENT_RESPONSE.SUCCESS) ||
              (data.ok && data.status === PAYMENT_RESPONSE.REVEIW) ||
              (data.ok && data.status === PAYMENT_RESPONSE.INITIATED)
            ) {
              let widget = document.getElementById('widgetWrapper');
              if (widget) {
                widget.remove();
              }
              this.setState({
                apiErrorMessages: [],
                documents: {
                  bestellID: data.bestellID
                },
                status: data.status
              });
              console.debug('Success: payment response data:', data);
              this.data.success = true;
              navigate('/success');
            } else {
              sessionStorage.clear();
              this.initializeData();
              console.debug('Error: payment response data:', data);
              navigate('/error');
            }
            this.ajaxLoading = false;
          },
          () => {
            this.creditCardStorno();
            this.ajaxLoading = false;
          }
        );
      } else {
        errorMessages = [{ validierungsText: `${i18n('Credit card payment failed')}` }];
      }
    }

    const { loading } = this.state;

    const props = {
      ...this.makeLinks(this.urls.payment, this.urls.summary, null),
      loading,
      paymentPending: this.ajaxLoading,
      onRender: this.resetApiErrors,
      onConfirm: this.placeOrder,
      apiErrorMessages: errorMessages.length ? errorMessages : this.state.apiErrorMessages,
      onChange: partial(this.updateData, 'summary'),
      data: { ...this.data.contract, ...this.data.personal, ...this.data.payment }
    };

    return <Summary {...props} />;
  };

  creditCardStorno = () => {
    const { navigate } = this.props.router;

    this.handleCreditCardPayment(this.params, true).then(
      () => {
        sessionStorage.clear();
        navigate('/error');
      },
      () => {
        sessionStorage.clear();
        navigate('/error');
      }
    );
  };

  renderSuccessPage = () => {
    const { status } = this.state;

    if (!this.data.success) {
      return <Navigate replace to={this.urls.personal} />;
    }

    return (
      <PaymentSuccess
        status={status}
        onSuccess={() => {
          this.blockPayment = true;
        }}
        resetData={this.initializeData}
      />
    );
  };

  render() {
    const prefix = window.base === '/' ? '' : window.base;
    const { restored } = this.state;

    if (!restored) {
      return null;
    }

    return (
      <div className="online-premium-payment">
        <Head
          title={i18n('Online Prämienzahlung')}
          steps={this.steps}
          showSteps={window.location.pathname !== `${prefix}/success` && window.location.pathname !== `${prefix}/error`}
        />
        <Routes>
          <Route exact path={this.urls.contract} Component={this.renderContractTypePage} />
          <Route exact path={this.urls.personal} Component={this.renderPersonalDataPage} />
          <Route exact path={this.urls.payment} Component={this.renderPaymentPage} />
          <Route path={this.urls.summary} Component={this.renderSummaryPage} />
          <Route path={this.urls.success} Component={this.renderSuccessPage} />
          <Route path={this.urls.error} element={<PaymentError />} />
          <Route path="/" element={<Navigate replace to={this.urls.contract} />} />
        </Routes>
      </div>
    );
  }
}

export default withRouter(LifeInsuranceFormMkdContainer);
